import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-364">
      <div className="max-w-4xl mx-auto text-center" data-id="element-365">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00C853]/50 text-[#00C853] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-366">
          🏆 Sistema N°1 para Profes de Baby Fútbol en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-367">
          ⚽ PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#00C853] mb-6" data-id="element-368">
          MEGAPACK BABYFÚTBOL LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-369">
          <strong data-id="element-370">6 Tomos + 6 Bonos — 4 a 12 años — Todo resuelto.</strong>
          <br data-id="element-371" />
          540+ páginas de contenido técnico y táctico completo. 480 sesiones
          listas para usar desde hoy. Planificación anual de 40 semanas por
          nivel lista para presentar.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-372">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-373">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['4-5', '6-7', '8-9', '10', '11-12', 'DT Kit'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #00C853'
            }} data-id="element-374">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-375">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00C853] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-376">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-377">
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-378">
            ✅ 4 a 12 años — Cancha de 5
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-379">
            ✅ 40 semanas + 80 sesiones por tomo
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-380">
            ✅ Correcciones técnicas y variantes incluidas
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-381">
            ✅ 100% contexto argentino de club de barrio
          </span>
        </div>
      </div>
    </section>;
}